export default __webpack_public_path__ + "static/media/click-plus.90338af0.svg";